const configurations = {
  headers: [
    { text: 'Datum', value: 'date' },
    { text: 'Antragsteller', value: 'applicant' },
    { text: 'Produktgruppe', value: 'product' },
    { text: 'Anschlussadresse', value: 'address' },
    { text: 'zul. bearbeitet von', value: 'lastChangedBy' },
    { text: 'Status', value: 'status' },
    { value: 'edit' },
  ],
};

export const getConstructionAndEventPowerTableConfig = (configName) =>
  JSON.parse(JSON.stringify(configurations[configName]));
